// extracted by mini-css-extract-plugin
module.exports = {"base":"Textarea__base___2G47k","invalid":"Textarea__invalid___EResH"};